import React from 'react';
import './App.scss';
import HeroSection from './components/HeroSection';
import TimelineSection from './components/TimelineSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import TopBanner from './components/TopBanner';
import BottomNavBar from './components/BottomNavBar';
import GrowthChartSection from './components/GrowthChartSection';
import TeamSection from './components/TeamSection';
import TokenomicsSection from './components/TokenomicsSection';
import RevenueProjectionsSection from './components/RevenueProjectionsSection';
import ExpressInterestSection from './components/ExpressInterestSection';
import RealEstateSection from './components/RealEstateSection';
import KeyDifferentiatorsSection from './components/KeyDifferentiatorsSection';
import HowItWorksSection from './components/HowItWorksSection';

function App() {
  return (
    <div className="App">
      <TopBanner />
      <div style={{ paddingTop: 54, paddingBottom: 54 }}>
        <section id="hero"><HeroSection /></section>
        <section id="timeline"><TimelineSection /></section>
        <section id="problem"><ProblemSection /></section>
        <section id="revenue"><RevenueProjectionsSection /></section>
        <section id="solution"><SolutionSection /></section>
        <section id="howitworks"><HowItWorksSection /></section>
        <section id="keydifferentiators"><KeyDifferentiatorsSection /></section>
        <section id="realestate"><RealEstateSection /></section>
        <section id="growth"><GrowthChartSection /></section>
        <section id="team"><TeamSection /></section>
        <section id="tokenomics"><TokenomicsSection /></section>
        <section id="express-interest"><ExpressInterestSection /></section>
      </div>
      <BottomNavBar />
    </div>
  );
}

export default App;
